import { render, staticRenderFns } from "./viewPage.vue?vue&type=template&id=2a2c5868&scoped=true&"
import script from "./viewPage.vue?vue&type=script&lang=js&"
export * from "./viewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2c5868",
  null
  
)

export default component.exports